import { render } from "./TableHeaderCell.vue?vue&type=template&id=e76100d6&ts=true"
import script from "./TableHeaderCell.vue?vue&type=script&lang=ts"
export * from "./TableHeaderCell.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__